import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

// Six core advisory services. Each has a slug, icon, short summary (for the
// homepage card) and long content (for the dedicated service detail page).
// Images are dark, cinematic, royalty-free Unsplash editorial sources chosen
// to align with the Mayfair private advisory aesthetic. They use the
// Unsplash CDN's auto-format/crop parameters for fast delivery.
export const SERVICE_CATEGORIES = [
    {
        slug: 'property-consultancy',
        name: 'Property Consultancy',
        icon: 'Building2',
        summary: 'Advisory across residential, commercial and mixed-use property matters — from pre-deal review to structuring.',
        topic: 'Property Consultancy',
        image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1600&q=80',
        long: [
            'We act as a senior point of contact across residential, commercial and mixed-use property matters — including pre-deal review, structuring guidance and coordination with surveyors, lenders and counsel.',
            'Engagements range from a single confidential consultation to longer-form coordination across a transaction. Each is scope-led and quoted privately.',
        ],
    },
    {
        slug: 'exotic-cars-asset-sourcing',
        name: 'Exotic Cars & Asset Sourcing',
        icon: 'Car',
        summary: 'Discreet sourcing of vehicles, watches and high-value assets, with verification and negotiation support.',
        topic: 'Exotic Cars & Asset Sourcing',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1600&q=80',
        long: [
            'Discreet sourcing of vehicles, watches and other high-value assets for private clients. We coordinate verification, negotiation and trusted dealer relationships, and handle the parts of the process that benefit from a private intermediary.',
            'All engagements are confidential. Clients are introduced only to vetted counterparties.',
        ],
    },
    {
        slug: 'commodities-trade',
        name: 'Commodities & Trade',
        icon: 'Boxes',
        summary: 'Practical guidance on commodity transactions, sourcing routes, counterparty review and terms.',
        topic: 'Commodities & Trade',
        image: 'https://images.unsplash.com/photo-1494412651409-8963ce7935a7?auto=format&fit=crop&w=1600&q=80',
        long: [
            'Practical guidance on commodity transactions, sourcing routes, counterparty diligence and trade terms. We work alongside in-house teams, brokers and regulated advisors to put structure and accountability around international trade matters.',
            'Sessions are typically one-off consultations or short coordinated engagements, scoped to the specific transaction.',
        ],
    },
    {
        slug: 'legal-consulting',
        name: 'Legal Consulting',
        icon: 'FileSearch',
        summary: 'Independent strategic advice on commercial, contractual and dispute matters with specialist coordination.',
        topic: 'Legal Consulting',
        image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80',
        long: [
            'Independent strategic advice on commercial, contractual and dispute-related questions — with referral to and coordination of regulated specialists where formal representation is required.',
            'We focus on what your decision actually needs: a clear view of options, a sober read of risk and a defined next step.',
        ],
    },
    {
        slug: 'banking-finance-consulting',
        name: 'Banking & Finance Consulting',
        icon: 'Landmark',
        summary: 'Guidance on banking relationships, financing structures, payments and treasury arrangements.',
        topic: 'Banking & Finance Consulting',
        image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1600&q=80',
        long: [
            'Guidance on banking relationships, financing structures, payment arrangements and treasury matters. We help clients prepare for account opening, navigate compliance requirements and structure international payments with discipline.',
            'Banking decisions sit at the intersection of strategy, regulation and reputation. We treat them accordingly.',
        ],
    },
    {
        slug: 'technology-business-consulting',
        name: 'Technology & Business Consulting',
        icon: 'CircuitBoard',
        summary: 'Advisory on digital strategy, vendor selection and IT investment decisions for growing businesses.',
        topic: 'Technology & Business Consulting',
        image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80',
        long: [
            'Advisory on digital strategy, vendor selection, IT investment decisions and growth planning. We provide an outside, commercially literate perspective on technology choices that quietly shape a business for years.',
            'Engagements are positioned to support founders, boards and operating teams making the next material decision.',
        ],
    },
];

export function findCategory(slug) {
    return SERVICE_CATEGORIES.find((c) => c.slug === slug);
}

export function formatGBP(n) {
    try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 2 }).format(Number(n || 0));
    } catch {
        return `\u00a3${Number(n || 0).toFixed(2)}`;
    }
}

export function formatDate(iso) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
        return iso;
    }
}
